import { render } from "./UserLoginForm.vue?vue&type=template&id=9be305ce"
import script from "./UserLoginForm.vue?vue&type=script&lang=js"
export * from "./UserLoginForm.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\projects\\external\\kazigraphix\\admin.kazigraphix\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__